module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "managerapprove"
  }, [_vm._l((_vm.headerNotiApprove.rows), function(headerApp) {
    return [_c('router-link', {
      attrs: {
        "to": {
          name: headerApp.key
        }
      }
    }, [_c('div', {
      staticClass: "block-item"
    }, [_c('div', {
      staticClass: "menu-icon fa",
      class: headerApp.option2
    }, [_c('i', {
      staticClass: "fa",
      class: headerApp.option1
    })]), _vm._v(" "), _c('div', {
      staticClass: "menu-codapp"
    }, [_vm._v(_vm._s(headerApp.key))]), _vm._v(" "), (headerApp.summary <= 999) ? _c('div', {
      staticClass: "menu-summary summary-",
      class: headerApp.key
    }, [_vm._v(_vm._s(headerApp.summary))]) : _c('div', [_vm._v("999+")]), _vm._v(" "), _c('div', {
      staticClass: "menu-text"
    }, [_vm._v(_vm._s(headerApp.values))])])])]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerNotiApprove.rows.length == 0),
      expression: "headerNotiApprove.rows.length == 0"
    }],
    staticClass: "no-pending"
  }, [_vm._v(_vm._s(_vm.labels[_vm.dash.nowLang]['no_pending']))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22f0dfe5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/managerapprove/component.vue
// module id = 3625
// module chunks = 1